<template>
  <div class="rb-share-nav">
    <span>Share Product:</span>
    <div class="rb-share-options">
      <a
        target="_blank"
        :href="`mailto:?subject= I want to share this with you &amp;body= ${data.socialShare.emailText} ${urlShare}!`"
        @click="notifyShare"
        id="btn-share-mail"
        aria-label="Share this product via Email"
        ><icon-envelope
      /></a>
      <a
        target="_blank"
        :href="`https://www.facebook.com/sharer/sharer.php?u=${urlShare}`"
        @click="notifyShare"
        id="btn-share-facebook"
        aria-label="Share this product on Facebook"
        ><icon-facebook
      /></a>
      <a
        target="_blank"
        :href="`https://twitter.com/share?url=${urlShare}`"
        @click="notifyShare"
        id="btn-share-twitter"
        aria-label="Share this product on Twitter"
        ><icon-twitter
      /></a>
      <a
        target="_blank"
        :href="`//pinterest.com/pin/create/button/?url=${urlShare}&media=${urlProductImage}&description=${productTitle}`"
        @click="notifyShare"
        id="btn-share-pinterest"
        aria-label="Share this product on Pinterest"
        ><icon-pinterest
      /></a>
    </div>
  </div>
</template>
<script>
/**
 * Widget with social share links
 *
 * @implements
 * TrackMixin
 *
 * @props
 * data: Object
 *
 */
import TrackMixin from "@/mixins/TrackMixin";
import IconTwitter from "@/components/icons/IconTwitter";
import IconFacebook from "@/components/icons/IconFacebook";
import IconPinterest from "@/components/icons/IconPinterest";
import IconEnvelope from "@/components/icons/IconEnvelope";
export default {
  mixins: [TrackMixin],
  components: {
    IconTwitter,
    IconFacebook,
    IconPinterest,
    IconEnvelope,
  },
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    urlShare: function () {
      if (!this.data) return "";
      return this.data.urlShop + "/products/" + this.data.product.handle;
    },
    urlProductImage: function () {
      return this.data.product.featured_image;
    },
    productTitle: function () {
      return encodeURIComponent(this.data.product.title);
    },
  },
  methods: {
    notifyShare: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
  },
};
</script>
